import { Component, input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    imports: [MatProgressSpinner],
})
export class LoadingIndicatorComponent {
  loading = input<boolean>(false);
}
